import * as HELPERS from "@/pixels/utils/helpers";

describe("helpers config", () => {
  it("test emulando desktop", () => {
    global.navigator = {
      userAgent:
        "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537"
    };
    expect(HELPERS._isMobile()).toBe(false);
  });

  it("test emulando Mobile", () => {
    Object.defineProperty(navigator, "userAgent", { value: "iPhone" });
    global.navigator = {
      userAgent: "iphone"
    };

    const result = HELPERS._isMobile();
    expect(result).toBe(true);
  });

  describe("test _normalizeCharacters", () => {
    it("deberia quitar acentos y pasar a minusculas", () => {
      expect(HELPERS._normalizeCharacters("ÁÉÍÓÚáéíóúÑñ")).toBe("aeiouaeiounn");
    });
    it("deberia devolver el mismo valor para input sin acentos", () => {
      expect(HELPERS._normalizeCharacters("abc")).toBe("abc");
    });
    it("deberia devolver lo mismo si es falsy", () => {
      expect(HELPERS._normalizeCharacters("")).toBe("");
    });
  });

  describe("test _normalizeCurrency", () => {
    it("deberia devolver 'USD' para 'dol'", () => {
      expect(HELPERS._normalizeCurrency("dol")).toBe("USD");
      expect(HELPERS._normalizeCurrency("DOL")).toBe("USD");
    });
    it("deberia devolver 'EUR' para 'eur'", () => {
      expect(HELPERS._normalizeCurrency("eur")).toBe("EUR");
    });
    it("deberia devolver lo mismo si es falsy", () => {
      expect(HELPERS._normalizeCurrency("")).toBe("");
    });
  });

  describe("test _normalizeGender", () => {
    it("deberia reemplazar 'm' por 'masculino'", () => {
      expect(HELPERS._normalizeGender("m")).toBe("masculino");
      expect(HELPERS._normalizeGender("M")).toBe("masculino");
    });
    it("deberia reemplazar 'f' por 'femenino'", () => {
      expect(HELPERS._normalizeGender("f")).toBe("femenino");
      expect(HELPERS._normalizeGender("F")).toBe("femenino");
    });
    it("deberia devolver el valor si no esta mapeado", () => {
      expect(HELPERS._normalizeGender("x")).toBe("x");
      expect(HELPERS._normalizeGender("otro")).toBe("otro");
    });
    it("deberia devolver lo mismo si es falsy", () => {
      expect(HELPERS._normalizeGender("")).toBe("");
    });
  });

  describe("getGlobalApplication", () => {
    it("deberia devolver 'doble play' para _BBVA_MOTOR ofertaCGU", () => {
      global._BBVA_MOTOR = "ofertaCGU";
      expect(HELPERS.getGlobalApplication()).toBe("doble play");
    });

    it("deberia devolver 'onboarding payroll' para _BBVA_MOTOR ofertaNomina", () => {
      global._BBVA_MOTOR = "ofertaNomina";
      expect(HELPERS.getGlobalApplication()).toBe("onboarding payroll");
    });

    it("deberia devolver 'doble play' para _BBVA_MOTOR ofertaCajaAhorro", () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      expect(HELPERS.getGlobalApplication()).toBe("doble play");
    });

    it("deberia devolver 'doble play' para _BBVA_MOTOR ofertaEmprendedores", () => {
      global._BBVA_MOTOR = "ofertaEmprendedores";
      expect(HELPERS.getGlobalApplication()).toBe("doble play");
    });

    it("deberia devolver 'onboarding payroll' para _BBVA_MOTOR unknown", () => {
      global._BBVA_MOTOR = "unknown";
      expect(HELPERS.getGlobalApplication()).toBe("onboarding payroll");
    });
    it("deberia devolver 'onboarding payroll' para _BBVA_MOTOR null", () => {
      global._BBVA_MOTOR = null;
      expect(HELPERS.getGlobalApplication()).toBe("onboarding payroll");
    });
  });

  describe("getApplicationName", () => {
    it("deberia devolver 'doble play' para _BBVA_MOTOR ofertaCGU", () => {
      global._BBVA_MOTOR = "ofertaCGU";
      expect(HELPERS.getApplicationName()).toBe("doble play");
    });

    it("deberia devolver 'circuito nominas' para _BBVA_MOTOR ofertaNomina", () => {
      global._BBVA_MOTOR = "ofertaNomina";
      expect(HELPERS.getApplicationName()).toBe("circuito nominas");
    });

    it("deberia devolver 'doble play' para _BBVA_MOTOR ofertaCajaAhorro", () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      expect(HELPERS.getApplicationName()).toBe("doble play");
    });

    it("deberia devolver 'doble play' para _BBVA_MOTOR ofertaEmprendedores", () => {
      global._BBVA_MOTOR = "ofertaEmprendedores";
      expect(HELPERS.getApplicationName()).toBe("doble play");
    });

    it("deberia devolver 'circuito nominas' para _BBVA_MOTOR unknown", () => {
      global._BBVA_MOTOR = "unknown";
      expect(HELPERS.getApplicationName()).toBe("circuito nominas");
    });

    it("deberia devolver 'circuito nominas' para _BBVA_MOTOR null", () => {
      global._BBVA_MOTOR = null;
      expect(HELPERS.getApplicationName()).toBe("circuito nominas");
    });
  });

  describe("test getFulfillmentModel", () => {
    it("deberia devolver 'online' _BBVA_MOTOR para ofertaCGU", () => {
      global._BBVA_MOTOR = "ofertaCGU";
      expect(HELPERS.getFulfillmentModel()).toBe("online");
    });

    it("deberia devolver 'offline' para _BBVA_MOTOR ofertaNomina", () => {
      global._BBVA_MOTOR = "ofertaNomina";
      expect(HELPERS.getFulfillmentModel()).toBe("offline");
    });

    it("deberia devolver 'online' para _BBVA_MOTOR ofertaCajaAhorro", () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      expect(HELPERS.getFulfillmentModel()).toBe("online");
    });

    it("deberia devolver 'online' para _BBVA_MOTOR ofertaEmprendedores", () => {
      global._BBVA_MOTOR = "ofertaEmprendedores";
      expect(HELPERS.getFulfillmentModel()).toBe("online");
    });

    it("deberia devolver 'offlines' para _BBVA_MOTOR unknown", () => {
      global._BBVA_MOTOR = "unknown";
      expect(HELPERS.getFulfillmentModel()).toBe("offline");
    });

    it("deberia devolver 'offline' para _BBVA_MOTOR null", () => {
      global._BBVA_MOTOR = null;
      expect(HELPERS.getFulfillmentModel()).toBe("offline");
    });
  });

  describe("test getTypology", () => {
    it("deberia devolver 'cuenta gratuita universal' _BBVA_MOTOR para ofertaCGU", () => {
      global._BBVA_MOTOR = "ofertaCGU";
      expect(HELPERS.getTypology()).toBe("cuenta gratuita universal");
    });

    it("deberia devolver 'caja de ahorro nominas' para _BBVA_MOTOR ofertaNomina", () => {
      global._BBVA_MOTOR = "ofertaNomina";
      expect(HELPERS.getTypology()).toBe("caja de ahorro nominas");
    });

    it("deberia devolver 'caja de ahorro tradicional' para _BBVA_MOTOR ofertaCajaAhorro", () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      expect(HELPERS.getTypology()).toBe("caja de ahorro tradicional");
    });

    it("deberia devolver 'caja de ahorro openpay' para _BBVA_MOTOR ofertaEmprendedores", () => {
      global._BBVA_MOTOR = "ofertaEmprendedores";
      expect(HELPERS.getTypology()).toBe("caja de ahorro openpay");
    });

    it("deberia devolver 'caja de ahorro nominas' para _BBVA_MOTOR unknown", () => {
      global._BBVA_MOTOR = "unknown";
      expect(HELPERS.getTypology()).toBe("caja de ahorro nominas");
    });

    it("deberia devolver 'caja de ahorro nominas' para _BBVA_MOTOR null", () => {
      global._BBVA_MOTOR = null;
      expect(HELPERS.getTypology()).toBe("caja de ahorro nominas");
    });
  });

  describe("test getOffer", () => {
    it("deberia devolver 'caja de ahorro' para camino 1", () => {
      const context = { state: { dataQuery: { camino: 1 } } };
      expect(HELPERS.getOffer(context)).toBe("caja de ahorro");
    });

    it("deberia devolver 'oferta paquete' para camino 2", () => {
      const context = { state: { dataQuery: { camino: 2 } } };
      expect(HELPERS.getOffer(context)).toBe("oferta paquete");
    });

    it("deberia devolver 'en base nominas' para camino 3", () => {
      const context = { state: { dataQuery: { camino: 3 } } };
      expect(HELPERS.getOffer(context)).toBe("en base nominas");
    });

    it("deberia devolver 'no esta en base' para camino 4", () => {
      const context = { state: { dataQuery: { camino: 4 } } };
      expect(HELPERS.getOffer(context)).toBe("no esta en base");
    });

    it("deberia devolver 'con ca existente' para camino 5", () => {
      const context = { state: { dataQuery: { camino: 5 } } };
      expect(HELPERS.getOffer(context)).toBe("con ca existente");
    });

    it("deberia devolver '' para camino no definido", () => {
      const context = { state: { dataQuery: { camino: null } } };
      expect(HELPERS.getOffer(context)).toBe("");
    });
  });
});
